import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/pc/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/mHome",
    name: "mHome",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/mobile/Home.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/pc/About.vue"),
  },
  {
    path: "/city",
    name: "City",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/mobile/City.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
